<template lang="pug">
section.wam-content.onboarding-dem(:class="{'full-width': isLoading || isUpdating }")

    //- Loading data
    template(v-if="isLoading || isUpdating")
        spinner.l-flex-row--center.l-align-center(width="200" height="200")

    template(v-else)
        //- CONNECTIONS > CONFIGURATIONS
        Panel(panelClassName="connection-panel")
            template(slot="header")
                sectionHeader(title="Connections")
                    template(slot="action")
                        div.section-header--action
                            div.section-header--action-item.action-item-direct.l-flex-row
                                button(
                                    class="btn-border btn--small btn--round l-flex-row l-align-center"
                                    @click="newEntry"
                                    :class="{'ui-disabled': disabledDEMAction || isLoading}")
                                    | New Entry
                                button.btn-search.btn-pale.btn--small.btn--round.l-flex-row.l-align-center(
                                    @click="resetConfigSelection()"
                                    :class="{'ui-disabled': !filterActive}")
                                    | All jobs
                            //- div.section-header--action-item.action-hidden-menu
                                svg-icon(name='dots' size="large")
                                div.menu-action-hidden
                                    div.l-flex-row
                                        svg-icon(name='dots' size="large")
                                    ul
                                        li.dot-menu-item(
                                        @click="resetConfigSelection()"
                                        :class="{'is-active': !filterActive}") All jobs

            template(slot="content")
                ul.list_connection.scrollbar.is-scrollable
                    li.list-item_connection(
                        v-for="connection of getConnectionList()"
                        :class="{'has-no-config': !connection.hasChild}")
                        div.list-item_connection-info
                            div.list-item_icons(@click.stop="showInfo(connection.id)" v-if="connection.hasChild")
                                svg-icon.list-item_arrow(name='arrow_right' size="small" :class="{'rotate-90': connectionInfoExpanded(connection.id)}")
                                svg-icon.list-item_folder(name='folder' size="small" :class="{'open-folder': connectionInfoExpanded(connection.id)}")
                            div.list-item_label(
                                :class="{'is-danger': connection.status === 'failed'}"
                                :title="connection.label"
                            ) {{ connection.label }}
                            div.list-item_type {{ connection.type.toUpperCase() }}
                            div.list-item_action-connection(
                                :class="{'ui-disabled': disabledDEMAction}"
                            )
                                svg-icon.list-item_edit(
                                    name='add' size="small" title="add configuration"
                                    @click.native="addConfiguration(connection.id)")
                                svg-icon.list-item_edit(
                                    name='edit' size="small" title="edit connection"
                                    @click.native="editOnboardingEntry(connection)")
                                svg-icon.list-item_trash(
                                    name='trash' size="small" title="delete connection"
                                    @click.native="removeItem(connection, 'connection')")

                        transition(name="slide-fade")
                            ul.list-config(v-if="connectionInfoExpanded(connection.id)")
                                li.list-item_config(
                                    v-for="config of getConfigurationListByParentJsonKeyName({ jsonKeyName: connection.jsonKey.name })"
                                    :class="{'is-selected': selectedConfig === config.jsonKey.name}"
                                    @click="selectConfig(config.jsonKey.name)")

                                    div.list-item_label(:title="config.label") {{ config.label }}
                                    div.list-item_type {{ config.jsonKey.subType }}
                                    div.list-item_action-config(
                                        :class="{'ui-disabled': disabledDEMAction}"
                                    )
                                        svg-icon.list-item_edit(
                                            :class="{'ui-disabled': isUpdating}"
                                            name='edit' size="small"
                                            @click.native="editOnboardingEntry(config)")
                                        svg-icon.list-item_trash(
                                            name='trash' size="small"
                                            @click.native="removeItem(config, 'configuration')")

        //- JOBS MONITORING
        DemJobs(:class="{'dem-monitoring-is-loading': false}", :jobs="jobs")

        //- PANEL JOB INFORMATION
        Panel(panelClassName="jobs-information" v-if="selectedJobId !== null")
            template(slot="header")
                sectionHeader(title="details")
            template(slot="content")
                JobsDetails(:jobList="jobs")
        div.jobs-information.no-data-selected(v-else)
            p No job selected.
              br
              | Please select a job.

        //- Modal FORM CONNECTION + FORM CONFIG
        div.overlay-close(
            v-if="displayModal"
            @click="closeForm()")
        div.modal(
            v-if="displayModal"
            class="modal-h-full modal__medium modal-dem")
            DemForm

</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
// Components
import DemForm from '@/components/onBoarding/DemForm'
import DemJobs from '@/components/onBoarding/DemJobs'
import JobsDetails from '@/components/onBoarding/JobsDetails'
import Panel from '@/components/common/Panel'
import SectionHeader from '@/components/common/SectionHeader'
// Library
import { filter, find, isEmpty, includes, isNil, cloneDeep } from 'lodash'
// Constants
import { DEM_CONNECTION_FORM_DATA, DEM_CONFIGURATION_FORM_DATA } from '@/utils/constants'

export default {
    name: 'ManageDataEntry',
    components: { DemForm, DemJobs, JobsDetails, Panel, SectionHeader },

    data() {
        return {
            expandedConnectionsIds: [],
            selectedConfig: ''
        }
    },

    mounted() {
        if (this.hasUserAccessToDEM && isEmpty(this.dataEntryList)) {
            this.setIsLoading(true)
            this.retrieveDataEntry()
        }
    },

    watch: {
        hasUserAccessToDEM: {
            handler: function(val, oldVal) {
                if (val !== oldVal && val) this.retrieveDataEntry()
            }
        }
    },

    computed: {
        // Call to state
        ...mapState('ui/dataEntry', {
            searchFiltersJsonKeyNames: state => state.searchFilters.jsonKeyNames,
            displayModal: state => state.displayModal,
            isUpdating: state => state.isLoading,
            selectedJobId: state => state.selectedRowId
        }),
        ...mapState('data/dataEntry', {
            dataEntryList: state => state.list
        }),
        ...mapGetters('data/dataEntry', [
            'getConnectionList',
            'getConfigurationListByParentJsonKeyName',
            'getJobList',
            'getJobListByParentJsonKeyName',
            'getItemById'
        ]),
        ...mapGetters('ui/dataEntry', ['notReadyIsLoading']),
        ...mapGetters('account', ['getAccessToDEM', 'getIsDEMActionAllowed']),
        ...mapGetters('ui/builder', ['criteriaListIsReady']),

        hasUserAccessToDEM() {
            return this.getAccessToDEM()
        },

        disabledDEMAction() {
            return !this.getIsDEMActionAllowed()
        },

        isLoading() {
            return !this.criteriaListIsReady
        },

        displayAllJobs() {
            return this.selectedConfig === '' && isNil(this.searchFiltersJsonKeyNames)
        },
        jobs() {
            return this.displayAllJobs ? this.getJobList() : this.getJobListByParentJsonKeyName({ jsonKeyName: this.selectedConfig })
        },
        selectedJob() {
            if (isEmpty(this.jobs)) return null
            const _job = find(this.jobs, job => job.id === this.selectedJobId)
            return isNil(_job) ? null : _job
        },
        filterActive() {
            return this.searchFiltersJsonKeyNames !== null
        },
        configIsSelected() {
            return this.selectedConfig !== ''
        }
    },

    methods: {
        // Call to mutations
        ...mapMutations('ui/dataEntry', [
            'setSearchFilter',
            'setDisplayModal',
            'setEditForm',
            'setFormConnection',
            'setFormConfiguration',
            'setCloseModal',
            'setFormAction',
            'setStep',
            'setConnectionId',
            'setIsLoading'
        ]),
        ...mapMutations('ui/dataEntry', ['setSelectedRow']),
        // Call to actions
        ...mapActions('data/dataEntry', ['retrieveDataEntry', 'deleteItem', 'addConfigurationItem']),

        showInfo(connectionId) {
            if (includes(this.expandedConnectionsIds, connectionId)) {
                this.expandedConnectionsIds = filter(this.expandedConnectionsIds, id => id !== connectionId)
            } else {
                this.expandedConnectionsIds.push(connectionId)
            }
        },
        connectionInfoExpanded(connectionId) {
            return includes(this.expandedConnectionsIds, connectionId)
        },

        isProxyConfiguration(data) {
            return typeof data.is_proxy_mode !== 'undefined' && parseInt(data.is_proxy_mode) === 1
        },

        isConnectionLinkedToProxy(data) {
            let hasProxy = false

            if (typeof data.children !== 'undefined') {
                hasProxy = data.children.filter(config => parseInt(config.is_proxy_mode) === 1).length > 0
            }
            return hasProxy
        },

        selectConfig(jsonKeyName) {
            this.selectedConfig = this.selectedConfig === jsonKeyName ? '' : jsonKeyName
            this.setSelectedRow({ rowId: null })
            this.setSearchFilter({
                filter: 'jsonKeyNames',
                value: jsonKeyName
            })
        },

        resetConfigSelection() {
            this.selectedConfig = ''
            this.setSearchFilter({
                filter: 'jsonKeyNames',
                value: null
            })
        },
        removeItem(data, type) {
            this.$msgbox
                .confirm(`You are about to permanently delete ${type} '${data.label}' . Do you want to proceed?`, 'Warning', {
                    type: 'warning',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No'
                })
                .then(() => {
                    this.deleteItem({ dataType: type, itemId: data.id })
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    })
                })
        },

        editOnboardingEntry(data) {
            const dataType = data.jsonKey.type
            if (dataType === 'connection') {
                this.setFormConnection({
                    formConnection: {
                        ...data,
                        type: data.type === 'sftp_pwd' || data.type === 'sftp_key' ? 'sftp' : data.type,
                        password: data.type === 's3' ? data.connector_key : data.password,
                        sftpType: data.type === 'sftp_pwd' || data.type === 'sftp_key' ? data.type : 'sftp_pwd',
                        connector_key: data.type === 's3' ? null : data.connector_key
                    }
                })
            } else if (dataType === 'configuration') {
                this.setFormConfiguration({
                    formConfiguration: {
                        id: data.id,
                        label: data.label,
                        task: JSON.stringify([data.task]),
                        frequency: data.frequency,
                        finish_alert_emails: data.finish_alert_emails,
                        remote_path: data.remote_path,
                        file_pattern: data.file_pattern,
                        is_weboid_crypted: data.is_weboid_crypted,
                        delimitor: data.delimitor,
                        idcrm_pattern: data.idcrm_pattern,
                        out_idcrm_pattern: data.out_idcrm_pattern,
                        proxy_name: data.proxy_name,
                        is_file_compressed: data.is_file_compressed,
                        remove_remote_files: data.remove_remote_files
                    }
                })
            }

            this.setDisplayModal({ display: true })
            this.setEditForm({
                action: 'edit',
                id: dataType === 'connection' ? data.id : data.connector_cred_id,
                formType: dataType
            })
        },

        closeForm() {
            if(!this.notReadyIsLoading){
                this.setCloseModal()
                this.setFormConnection({ formConnection: cloneDeep(DEM_CONNECTION_FORM_DATA) })
                this.setFormConfiguration({ formConfiguration: cloneDeep(DEM_CONFIGURATION_FORM_DATA) })
            }
        },

        addConfiguration(connectionId) {
            this.addConfigurationItem({
                formConfiguration: cloneDeep(DEM_CONFIGURATION_FORM_DATA),
                connectionId: connectionId
            })
        },
        // Form
        newEntry() {
            if (isEmpty(this.dataEntryList)) {
                // Set a temporary id to display form connection save & cancel buttons
                this.setConnectionId({ id: 0 })
            }
            this.setFormConnection({ formConnection: cloneDeep(DEM_CONNECTION_FORM_DATA) })
            this.setFormConfiguration({ formConfiguration: cloneDeep(DEM_CONFIGURATION_FORM_DATA) })
            this.setFormAction({ action: 'create' })
            this.setDisplayModal({ display: true })
        },
    }
}
</script>
